/*
**************************** 
홈페이지 런처 구매 리스트
*****************************
*/

import axios from "axios";
import React, { useEffect, useState } from "react";
import "../css/Pagination.scss";
import BuyOrder from "./BuyOrder";

export default function BuyTocTocBox(props) {
    const [userData, setUserData] = useState({ username: "", name: "", email: "", phone: "", address: "", subAddress: "", password: "", });
    const [valueData, setValueData] = useState([]);

    const reqProduct = async function () {
        const reqSql = "/api/product/toktokbox";
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.data.t_count >= 0) {
                const data = res.data.t_data;
                setValueData(data);
            } else {
                if (res.status === 400) {
                    alert("세션 만료 로그인이 필요합니다.");

                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            if (err.code === "ERR_BAD_REQUEST") {
                alert("세션 만료 로그인이 필요합니다.");

            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    useEffect(() => {
        reqProduct();
    }, []);

    return (
        <div className="mt-5 pt-2">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">구매하기</a></li>
                    <li className="breadcrumb-item active small">톡톡박스</li>
                </ol>
            </nav>
            <div className="container">
                <main>
                    <div className="row row-cols-md-3">
                        {valueData.length > 0 ? valueData.map(function (cell, idx) {
                            const idAdd = "#" + cell.product_key + "_" + cell.id;
                            let msg = cell.msg.replace(/\n/gi, " ");
                            let shortStr = (msg.length > 40 ? msg.slice(0, 40) + "..." : msg);
                            return (
                                <div key={idx}>
                                    <div className="col pt-3">
                                        <div className="card rounded-3 shadow-sm" >
                                            <div className="card-body" >
                                                <img className="img-thumbnail" src={cell.product_thum_image}></img>
                                                <ul className="list-unstyled mt-3 mb-4">
                                                    <li className="text-start my-3 fw-4">{shortStr}</li>
                                                </ul>
                                                {cell.product_type === "btb_package" ? <button type="button" className="w-100 btn btn-lg btn-primary" onClick={() => {
                                                    window.Gitple('open');
                                                }} >문의하기 </button> : cell.product_type === "link_package" ? <button type="button" className="w-100 btn btn-lg btn-primary" onClick={() => {
                                                    window.open(cell.product_link_url, "_blank");
                                                }}>문의하기</button> : <button type="button" className="w-100 btn btn-lg btn-primary" data-bs-toggle="modal" data-bs-target={idAdd} onClick={()=>{
                                                    sessionStorage.setItem("buyLocation", "BuyTocTocBox");
                                                }}>구매하기 </button>}
                                            </div>
                                        </div>
                                    </div>
                                    <BuyOrder data={cell} user={userData}></BuyOrder>
                                </div>
                            )
                        }) : null}
                    </div>
                </main>
            </div>
        </div>
    )
}